import {AssetLinkType} from '@hconnect/common/types'
import type {AssetLink} from '@hconnect/common/types'
import {useNotification} from '@hconnect/uikit/src/common'
import {useMutation} from '@tanstack/react-query'
import {AxiosError} from 'axios'
import {useErrorHandler} from 'react-error-boundary'
import {useTranslation} from 'react-i18next'

import {mutations} from '../../../../api/mutations'
import {getSettingsQueryData, setSettingsQueryData} from '../../../common/providers/ApiInterface'
import type {ErrorResponse} from '../../../common/types'
import {notifyIfErrorMessage} from '../../../common/utils/errorHandling'

export const useAddSiloLink = (assetId: number) => {
  const {notify} = useNotification()
  const raiseError = useErrorHandler()
  const {t} = useTranslation()

  return useMutation<
    AssetLink,
    AxiosError<ErrorResponse>,
    Parameters<typeof mutations.addAssetLink>[0]
  >({
    mutationFn: mutations.addAssetLink,
    onError: (error) => {
      notifyIfErrorMessage(error.response?.data.detail, raiseError, notify)
    },
    onSuccess: (addedLink, variables) => {
      notify('success', t('success.addSiloLink'))
      // params valid for attached silos
      const assetLinkTypes = [AssetLinkType.Asset, AssetLinkType.Silo]
      const assetLinkParams = {
        plantCode: variables.plantCode,
        assetId,
        fromTypes: assetLinkTypes,
        toTypes: assetLinkTypes
      }
      const prevAssetsLinks = getSettingsQueryData('assetsLinks', [assetLinkParams])
      if (!prevAssetsLinks) return
      setSettingsQueryData('assetsLinks', [assetLinkParams], [...prevAssetsLinks, addedLink])
    }
  })
}
